import classNames from 'classnames'
import React from 'react'
import './ButtonToolbar.sass'

/* eslint-disable */
import { bsClass, getClassSet, splitBsProps } from '../../utils'

class ButtonToolbar extends React.Component {
  render() {
    const { className, ...props } = this.props
    const [bsProps, elementProps] = splitBsProps(props)

    const classes = getClassSet(bsProps)

    return (
      <div
        {...elementProps}
        role="toolbar"
        className={classNames(className, classes)}
      />
    )
  }
}

export default bsClass('button-toolbar', ButtonToolbar)



// WEBPACK FOOTER //
// ./components/ButtonToolbar/index.jsx